import Tree from './Tree';
export default Tree;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tree/index.js
// module id = 760
// module chunks = 0